import { useMemo } from 'react';
import { useAppSelector } from 'store/store-hooks';
import { selectFiles } from 'components/app/_mediator/app-files.slice';

export const useCreateStory = (includeProjectCheck: boolean = true) => {
  const selectedProject = useAppSelector((state) => state.projects.selectedProject);
  const { brokenFiles, isAudio, isVideo, isImage } = useAppSelector(selectFiles);

  const createStoryDisabled = useMemo(() => {
    return (includeProjectCheck && !selectedProject) || !!brokenFiles.length || !isAudio || !(isVideo || isImage);
  }, [includeProjectCheck, selectedProject, brokenFiles.length, isAudio, isVideo, isImage]);

  const createStoryTooltip = useMemo(() => {
    if (!createStoryDisabled) return 'Add a story to this project';
    if (includeProjectCheck && !selectedProject) return 'Select a project to create a story';
    if (brokenFiles.length) return `Cannot create story: ${brokenFiles[0].fileName} — file duration or size is 0`;
    if (!isAudio) return 'Cannot create story: No available audio file';
    if (!(isVideo || isImage)) return 'Cannot create story: No available video or image file';
    return 'Add a story to this project';
  }, [createStoryDisabled, includeProjectCheck, selectedProject, brokenFiles, isAudio, isVideo, isImage]);

  return { createStoryDisabled, createStoryTooltip };
};
